<template>
  <b-row>
    <b-col cols="12">
      <b-card>
        <div>
          <router-link :to="'/vehicles/create/'">
            <b-button variant="success" class="float-right mb-3">Neues Fahrzeug</b-button>
          </router-link>
          <b-table responsive bordered striped hover :items="list" :fields="fields">
            <!--<template v-slot:cell(driver)="data">
              {{ data.item.driver_name }}
            </template>-->
            <template v-slot:cell(model)="data">
              {{ data.item.manufacturer }} {{ data.item.model }}
            </template>
            <template v-slot:cell(status)="data">
              <div class="text-center">
                <h4>
                  <b-badge :variant="data.item.status | statusFilter">
                    {{ data.item.status }}
                  </b-badge>
                </h4>
              </div>
            </template>
            <template v-slot:cell(last_message_data)="data">
              <div class="scrollable">
                {{ data.item.last_message_data }}
              </div>
            </template>
            <template v-slot:cell(actions)="data">
              <div class="text-center">
              <router-link :to="'/vehicles/edit/' + data.item.id">
                <b-button type="primary" size="small" icon="fa-icon-edit">
                  Ändern
                </b-button>
              </router-link>
              </div>
            </template>
          </b-table>
        </div>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>

    import Resource from '@/api/resource';

    const vehicleResource = new Resource('vehicles');
    export default {
        name: "VehicleList",
        filters: {
            statusFilter(status) {
                const statusMap = {
                    'In Ordnung': 'success',
                    'TÜV fällig': 'danger',
                    'Sonstiges': 'warning',
                };
                return statusMap[status];
            },
        },
        data() {
            return {
                fields: [
                    {
                        key: 'registration_number',
                        label: 'Kennzeichen',
                        sortable: true,
                        thStyle: {
                            align: "center",
                            width: '120px'
                        },
                    },
                    {
                        key: 'model',
                        label: 'Fahrzeugmodell',
                        sortable: true,
                        thStyle: {
                            width: '180px'
                        },
                    },
                    {
                        key: 'area',
                        label: 'Einsatzort',
                        sortable: true,
                        thStyle: {
                            width: '180px'
                        },
                    },
                    {
                        key: 'driver',
                        label: 'Fahrer',
                        sortable: true,
                        thStyle: {
                            width: '180px'
                        },
                    },
                    /*{
                        key: 'status',
                        label: 'Status',
                        sortable:
                            true,
                        thStyle:
                            {
                                width: '110px'
                            }
                        ,
                    },
                    {
                        key: 'last_message_at',
                        label: 'Letzte Meldung',
                        sortable:
                            true,
                        thStyle:
                            {
                                width: '180px'
                            }
                        ,
                    },
                    {
                        key: 'last_message_data',
                        label: 'Meldung',
                        sortable:
                            false,
                        thStyle:
                            {
                                width: '180px'
                            }
                        ,
                    },*/
                    {
                        key: 'actions',
                        label: 'Aktionen',
                        sortable:
                            false,
                        thStyle:
                            {
                                width: '120px'
                            }
                        ,
                    }
                ],
                list: null,
                total: 0,
                listLoading: true,
                listQuery:
                    {
                        page: 1,
                        limit: 15,
                    },
            }
        },
        created() {
            this.getList();
        },
        methods: {
            async getList() {
                this.listLoading = true;
                const {data} = await vehicleResource.list(this.listQuery);
                this.list = data;
                this.total = data.length;
                this.listLoading = false;
                this.fillListFields();
            },
            fillListFields() {
                for (const element of this.list) {
                    element.driver = element.driver_name; //TODO Get these via ID and cache them!
                    element.area = element.area_name; //TODO Get these via ID and cache them!
                }
            }
        }

    }
</script>

<style scoped>
  /deep/ .table > tbody > tr > td {
    vertical-align: middle !important;
  }

  /deep/ .scrollable {
    max-height: 100px;
    overflow-y: auto;
  }
</style>
